import { Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { OperacaoScr } from "src/app/model/operacao-scr.model";
import { SolicitacaoHonraArquivoSCR } from "src/app/model/solicitacao-honra.model";
import { VerticeOperacaoScr } from "src/app/model/vertice-operacao-scr.model";

@Component({
    templateUrl: 'arquivo-popup.component.html',
    standalone: false
})
export class ArquivoPopupComponent implements OnInit {
    public operacaoScr:OperacaoScr;
    public solicitacaoHonraArquivo:SolicitacaoHonraArquivoSCR;

    constructor(private _activeModal: NgbActiveModal) {
    }

    ngOnInit(): void {
        this.operacaoScr = this.solicitacaoHonraArquivo.operacaoScrUtilizadaNaValidacao;
    }

    cancelar() {
        this._activeModal.dismiss({});
    }

    formataTipoVerticeScr(vertice: VerticeOperacaoScr): string {
        if (!vertice.prazoMaximoInclusive) {
            return vertice.tipoVertice.toUpperCase() + " ACIMA DE " + (Number(vertice.prazoMinimoInclusive) - 1);
        }
        return vertice.tipoVertice.toUpperCase() + " ENTRE " + vertice.prazoMinimoInclusive + " E " + vertice.prazoMaximoInclusive + " DIAS";
    }
}